import { Edit, useForm } from "@refinedev/antd";
import { HttpError } from "@refinedev/core";
import { Button, Form, Input, InputNumber, Select } from "antd";
import { useState } from "react";
import { IconDisplay } from "../../components/IconDisplay";
import { ImageUpload } from "../../components/ImageUpload";

export function BannerEdit() {
  const [showUpload, setShowUpload] = useState(false);

  const { formProps, saveButtonProps, query, formLoading } = useForm<any, HttpError, any>({
    resource: "banner",
    successNotification: (data) => {
      return {
        message: data?.data.message,
        type: "success",
      };
    },
    action: "edit",
  });

  const banner = query?.data?.data?.data;

  return (
    <Edit
      saveButtonProps={saveButtonProps}
      isLoading={formLoading}
      resource="banner"
      mutationMode="optimistic"
      title="Edit banner"
    >
      <Form {...formProps} layout="vertical">
        <Form.Item
          label="Title"
          name={["title"]}
          initialValue={banner?.title}
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>

        <Form.Item label="Description" name={["description"]} initialValue={banner?.description}>
          <Input.TextArea />
        </Form.Item>

        <Form.Item
          label="Status"
          name={["status"]}
          initialValue={banner?.status}
          rules={[{ required: true }]}
        >
          <Select>
            <Select.Option value="ACTIVE">ACTIVE</Select.Option>
            <Select.Option value="INACTIVE">INACTIVE</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item label="Priority" name={["priority"]} initialValue={banner?.priority ?? 0}>
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item label="Link" name={["link"]} initialValue={banner?.link}>
          <Input placeholder="https://... or /deeplink" />
        </Form.Item>

        <Form.Item label="Image" name="mediaID" initialValue={banner?.mediaID}>
          {!showUpload ? (
            <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
              <IconDisplay iconURL={banner?.mediaURL} width={64} height={64} borderRadius="8px" />
              <Button onClick={() => setShowUpload(true)}>Change Image</Button>
              <Button
                onClick={() => {
                  formProps.form?.setFieldsValue({ mediaID: null });
                  setShowUpload(true);
                }}
                disabled={!banner?.mediaID}
              >
                Remove Image
              </Button>
            </div>
          ) : (
            <ImageUpload uploadType="BANNER" />
          )}
        </Form.Item>
      </Form>
    </Edit>
  );
}


